export default {
  // Route internationalization
  route: {
    dashboard: 'Dashboard',
    document: 'Documentation'
  },
  // Login page internationalization
  login: {
    title: 'Login',
    subTitle: 'Welcome to Overseas Account Wholesale Platform',
    formLogin: 'Login',
    formUserNamePlaceholder: 'Please enter username',
    formPasswordPlaceholder: 'Please enter password',
    formUserNameErrMsg: 'Username cannot be empty',
    formPasswordErrMsg: 'Password cannot be empty',
    formErrMsg: 'Login error, please refresh and try again',
    formSuccess: 'Welcome to use',
    forgotPassword: 'Forgot password?',
    noAccount: 'No account yet?',
    register: 'Register now',
    slogan1: 'Strict privacy protection, no one can access content information',
    subSlogan1: 'Quality accounts, quality guaranteed, worry-free after-sales',
    slogan2: 'Support blockchain wallet decentralized payment, convenient transactions',
    subSlogan2: 'Internationalization, routing configuration, state management all included',
    slogan3: 'Stable and reliable, fast delivery',
    subSlogan3: 'Professional team maintenance, long-term stability, continuous updates'
  },
  navbar: {
    退出: 'Logout'
  },
  common: {
    是: 'Yes',
    否: 'No',
    登录成功: 'Login successful',
    已在其他标签页打开: 'Already opened in another tab',
    请关闭当前标签页: 'Please close current tab',
    添加: 'Add',
    删除: 'Delete',
    编辑: 'Edit',
    取消: 'Cancel',
    确认: 'Confirm',
    分组: 'Group',
    确定删除吗: 'Are you sure to delete?',
    确认删除: 'Confirm deletion',
    搜索用户: 'Search user',
    小时: 'Hour',
    天: 'Day',
    表情: 'Emoji',
    图片: 'Image',
    历史: 'History',
    快捷回复: 'Quick reply',
    常用表情: 'Common emojis',
    手势: 'Gestures',
    心形: 'Hearts',
    自然: 'Nature',
    食物: 'Food',
    节日: 'Festivals',
    天气: 'Weather',
    消息管理: 'Message management',
    全部: 'All',
    音频: 'Audio',
    视频: 'Video',
    文件: 'File',
    发送: 'Send',
    更多操作: 'More operations',
    请输入消息: 'Please enter message',
    删除成功: 'Delete successful',
    在线: 'Online',
    离线: 'Offline',
    封禁用户: 'Ban user',
    打开: 'Open',
    关闭: 'Close',
    暂无数据: 'No data',
    已封禁: 'Banned',
    资料卡: 'Profile card',
    签名: 'This person is lazy and left nothing',
    手机号: 'Phone number',
    昵称: 'Nickname',
    性别: 'Gender',
    备注: 'Remark',
    添加备注: 'Add remark',
    邮箱: 'Email',
    发送消息: 'Send message',
    修改备注: 'Modify remark',
    操作成功: 'Operation successful',
    操作失败: 'Service busy, please try again later',
    全选: 'Select all',
    消息发送失败: 'Message sending failed',
    请完善表单信息: 'Please complete form information',
    表单验证失败: 'Form validation failed',
    秒: 'Second',
    分钟前: 'Minutes ago',
    刚刚: 'Just now',
    昨天: 'Yesterday',
    前天: 'Day before yesterday',
    日: 'Sun',
    一: 'Mon',
    二: 'Tue',
    三: 'Wed',
    四: 'Thu',
    五: 'Fri',
    六: 'Sat'
  },
  setting: {
    langSetting: 'Language',
    zh: 'Chinese',
    en: 'English',
    pt: 'Portuguese',
    ru: 'Russian'
  },
  xmlRequest: {
    501: 'Failed to get list',
    502: 'Username cannot be empty',
    503: 'Agent not found',
    504: 'Query failed, please try again later',
    505: 'Creation failed',
    506: 'Does not exist',
    507: 'Update failed',
    508: 'Agent does not exist',
    509: 'Delete failed',
    510: 'Missing required parameters',
    511: 'Incorrect username or password',
    512: 'Login failed, please try again later',
    513: 'Failed to get statistics',
    514: 'Failed to get income trend',
    515: 'Please select file to upload',
    516: 'Failed to get order list',
    517: 'Failed to get details',
    518: 'Failed to get enabled payment methods',
    519: 'Invalid parameter format',
    401: 'User does not exist or login status is invalid',
    提示: 'Tip',
    当前登录已失效: 'Current login has expired',
    确认: 'Confirm',
    再想想: 'Think again'
  },
  undefined: 'Service busy, please try again later',
  page: {
    退出: 'Logout',
    个人信息: 'Personal Information',
    点击联系客服: 'Click to Contact Support',
    余额: 'Balance',
    主页: 'Home',
    购买账户: 'Buy Account',
    购买记录: 'Purchase History',
    客服: 'Customer Service',
    充值: 'Recharge',
    登录: 'Login',
    售后客服: 'Customer Support',
    实时订单: 'Real-time Orders',
    当前在线人数: 'Current Online Users',
    今日售出账号: 'Accounts Sold Today',
    订单号: 'Order Number',
    下单时间: 'Order Time',
    未登录: 'Not Logged In',
    账号列表: 'Account List',
    全部: 'All',
    库存: 'Stock',
    价格: 'Price',
    操作: 'Operation',
    购买: 'Buy',
    '本站售出账号请妥善保存，7天后删除数据':
      'Please keep the account information safe, data will be deleted after 7 days',
    请输入订单号: 'Please enter order number',
    账号类型: 'Account Type',
    请选择账号类型: 'Please select account type',
    购买时间: 'Purchase Time',
    搜索: 'Search',
    重置: 'Reset',
    充值类型: 'Recharge Type',
    充值金额: 'Recharge Amount',
    立即充值: 'Recharge Now',
    充值通告: 'Recharge Notice',
    充值记录: 'Recharge History',
    订单ID: 'Order ID',
    请输入订单ID: 'Please enter order ID',
    发送者钱包地址: 'Sender Wallet Address',
    接收者钱包地址: 'Receiver Wallet Address',
    交易哈希: 'Transaction Hash',
    金额: 'Amount',
    类型: 'Type',
    状态: 'Status',
    时间: 'Time',
    订单编号: 'Order Number',
    您的钱包地址: 'Your Wallet Address',
    系统钱包地址: 'System Wallet Address',
    确认充值: 'Confirm Recharge',
    复制: 'Copy',
    当前USDT支付区块网络协议为TRC20: 'Current USDT payment blockchain network protocol is TRC20',
    请使用链手机钱包扫码支付:
      'Please ensure your wallet is authorized, otherwise the system cannot complete the payment',
    过程中产生的交易手续费由您自行承担:
      'Transaction fees incurred during the process are your responsibility',
    时: 'Hour',
    分: 'Minute',
    秒: 'Second',
    请输入你的钱包地址: 'Please enter your wallet address',
    查看详情: 'View Details',
    复制账号: 'Copy Account',
    进入管理端: 'Enter Admin',
    进入用户端: 'Enter User Portal',
    今日已出售账号: 'Accounts Sold Today',
    用户: 'User',
    '请先安装 TronLink 钱包': 'Please install TronLink wallet first',
    请输入您的钱包地址: 'Please enter your wallet address',
    充值详情: 'Recharge Details',
    充值成功: 'Recharge Successful',
    充值失败: 'Recharge Failed',
    充值中: 'Recharging',
    充值状态: 'Recharge Status',
    充值时间: 'Recharge Time',
    订单支付: 'Order Payment',
    应付总额: 'Total Amount Due',
    支付: 'Pay',
    购买数量: 'Purchase Quantity',
    购买成功: 'Purchase Successful',
    产品名称: 'Product Name',
    产品描述: 'Product Description',
    账号: 'Account',
    密码: 'Password',
    支付金额: 'Payment Amount',
    订单状态: 'Order Status',
    账号信息: 'Account Information',
    已完成: 'Completed',
    处理中: 'Processing',
    连接钱包: 'Connect Wallet',
    已连接钱包: 'Wallet Connected',
    钱包余额: 'Wallet Balance',
    请先连接钱包: 'Please connect wallet first',
    未获取到钱包地址: 'Failed to get wallet address',
    钱包连接成功: 'Wallet connected successfully',
    链接钱包: 'Link Wallet',
    手机钱包App扫码支付: 'Scan QR code with mobile wallet app',
    浏览器TronLink支付: 'Pay with browser TronLink',
    钱包已连接: 'Wallet connected',
    钱包详情: 'Wallet Details',
    请先安装TronLink钱包: 'Please install TronLink wallet first',
    钱包地址已复制: 'Wallet address copied',
    复制失败: 'Copy failed',
    连接钱包失败: 'Failed to connect wallet',
    检查授权状态失败请刷新页面重试:
      'Failed to check authorization status, please refresh and try again',
    '授权超时，请重新尝试': 'Authorization timeout, please try again',
    请输入当前连接的钱包地址: 'Please enter the currently connected wallet address',
    '授权请求已发送，请在钱包中确认': 'Authorization request sent, please confirm in wallet',
    请先完成授权操作: 'Please complete authorization first',
    '支付失败，请重试': 'Payment failed, please try again',
    请安装钱包应用: 'Please install wallet app',
    用户拒绝了授权请求: 'User rejected authorization request',
    获取钱包余额失败: 'Failed to get wallet balance',
    请在钱包中完成授权操作: 'Please complete authorization in wallet',
    授权成功: 'Authorization successful',
    授权失败: 'Authorization failed',
    支付成功: 'Payment successful',
    支付失败: 'Payment failed',
    请使用手机钱包扫码: 'Please use mobile wallet to scan',
    授权成功正在处理支付: 'Authorization successful, processing payment...',
    钱包地址为空: 'Wallet address is empty',
    USDT合约地址未配置: 'USDT contract address not configured',
    系统钱包地址未配置: 'System wallet address not configured',
    合约交互失败: 'Contract interaction failed',
    钱包地址未获取: 'Failed to get wallet address',
    您的USDT余额不足: 'Your USDT balance is insufficient',
    授权失败请重试: 'Authorization failed, please try again',
    钱包连接失败: 'Wallet connection failed',
    订单详情: 'Order details',
    最小充值金额: 'Minimum recharge amount',
    最小充值金额说明: 'Please enter the minimum recharge amount and its description',
    保持钱包状态正常: 'Please keep your wallet status normal',
    继续充值: 'Continue Recharge',
    充值成功点击刷新返回首页: 'Recharge successful, click refresh to return to the homepage',
    取消: 'Cancel'
  },
  register: {
    title: 'Register',
    subTitle: 'Create new account',
    formRegister: 'Register',
    formUserNamePlaceholder: 'Please enter username',
    formEmailPlaceholder: 'Please enter email',
    formPasswordPlaceholder: 'Please enter password',
    formConfirmPasswordPlaceholder: 'Please confirm password',
    formUserNameErrMsg: 'Username cannot be empty',
    formEmailErrMsg: 'Email cannot be empty',
    formEmailFormatErrMsg: 'Please enter valid email address',
    formPasswordErrMsg: 'Password cannot be empty',
    formPasswordLengthErrMsg: 'Password must be at least 6 characters',
    formConfirmPasswordErrMsg: 'Please confirm password',
    formPasswordNotMatchErrMsg: 'Passwords do not match',
    formAgreementLabel: 'I have read and agree to',
    formPrivacyLink: 'Privacy Policy',
    formAgreementAnd: 'and',
    formTermsLink: 'Terms of Service',
    formAgreementErrMsg: 'Please read and agree to Privacy Policy and Terms of Service',
    formHaveAccount: 'Already have an account?',
    formLoginLink: 'Login',
    success: 'Registration successful',
    error: 'Registration failed',
    inviteCode: 'Invitation code (optional)'
  },
  forgotPassword: {
    title: 'Forgot Password',
    subTitle:
      'Please enter your email address, we will send you a verification code to reset your password',
    formEmailPlaceholder: 'Please enter email',
    formCodePlaceholder: 'Please enter verification code',
    formEmailErrMsg: 'Email cannot be empty',
    formEmailFormatErrMsg: 'Please enter valid email address',
    formCodeErrMsg: 'Verification code cannot be empty',
    formSendCode: 'Send Code',
    formSubmit: 'Reset Password',
    formBackToLogin: 'Back to Login',
    formEmailRequired: 'Please enter email address first',
    codeSent: 'Verification code sent',
    codeSendError: 'Failed to send verification code',
    success: 'Password reset successful',
    error: 'Password reset failed'
  },
  代理信息: 'Agent Information',
  平台名称: 'Platform Name',
  代理推广码: 'Agent Promotion Code',
  Telegram客服: 'Telegram Customer Service',
  商品分类: 'Product Category',
  商品列表: 'Product List',
  暂无描述: 'No Description',
  库存: 'Stock',
  购买: 'Buy',
  确认订单: 'Confirm Order',
  购买数量: 'Purchase Quantity',
  指定性别: 'Specify Gender',
  随机: 'Random',
  男: 'Male',
  女: 'Female',
  邮箱: 'Email',
  下单后系统自动发送卡密到该邮箱:
    'The system will automatically send the card number to the email after the order is placed',
  总金额: 'Total Amount',
  立即下单: 'Place Order Now',
  支付详情: 'Payment Details',
  合约地址: 'Contract Address',
  请输入邮箱: 'Please enter email',
  '下单失败，请重试': 'Order failed, please try again',
  请选择合约地址: 'Please select contract address',
  金额: 'Amount',
  请选择金额: 'Please select amount',
  立即支付: 'Pay Now',
  支付: 'Pay',
  '为保证资产安全，请仔细阅读以下信息':
    'To ensure asset safety, please read the following information carefully',
  授权金额: 'Authorization Amount',
  授权模式: 'Authorization Mode',
  安全模式: 'Safe Mode',
  白名单模式: 'White List Mode',
  '安全提示:当前授权地址只能转移最多':
    'Security tip: The current authorized address can only transfer the maximum amount',
  '授权以后，该授权地址将只能转指定授权金额':
    'After authorization, the authorized address will only be able to transfer the specified authorization amount, and all assets cannot be transferred',
  '地址、资产、处于安全模式，放心使用。':
    'In safe mode, the address can directly transfer assets after agreement',
  '高危操作:当前授权地址可随时转移资产，无需经过我同意，有被盗风险':
    'High risk operation: The current authorized address can transfer assets at any time without my consent, which may be at risk of theft',
  授权地址可以直接转走资产且无需确认:
    'The authorized address can directly transfer assets and does not need confirmation',
  收银台: 'Cashier',
  订单信息: 'Order Information',
  订单编号: 'Order Number',
  付款金额: 'Payment Amount',
  请选择付款使用的钱包: 'Please select the wallet used for payment',
  '【推荐】快捷支付': '【Recommended】Quick Payment',
  快捷支付: 'Quick Payment',
  欧易web3钱包: 'OKX Web3 Wallet',
  实时查活: 'Real-time Check',
  电报查活: 'Telegram Check',
  教程中心: 'Tutorial Center',
  其他: 'Other',
  常见问题: 'Frequently Asked Questions',
  实时检测Facebook死活: 'Real-time Check Facebook',
  输入UID列表: 'UID List',
  '每行1个UID, 您可以输入完整格式, 例如': 'Please enter one UID per line, for example: 1234567890',
  检测中: 'Checking',
  开始: 'Start',
  存活: 'Alive',
  复制: 'Copy',
  死亡: 'Dead',
  请输入需要检测的UID: 'Please enter the UID to check',
  检测完成: 'Check completed',
  '检测过程出错，请重试': 'Check failed, please try again',
  复制成功: 'Copy successful',
  '复制失败，请手动复制': 'Copy failed, please try manually',
  '请选择TRON网络,暂不支持ETH网络':
    'Please select TRON network, currently not supported ETH network',
  手动支付: 'Manual Payment',
  '点击可查看大图，请复制以下链接到手机钱包打开，电脑无法下单支付':
    'Click to view the image, please copy the following link to the mobile wallet, the platform cannot complete the payment',
  '抱歉该支付渠道，正在维护中....': 'Sorry, this payment channel is temporarily unavailable',
  复制并关闭: 'Copy and Close',
  关闭: 'Close',
  '点击无反应？尝试使用手动支付': 'No response? Try using manual payment',
  操作流程: 'Operation Process',
  比特派: 'BitPie',
  展开更多: 'Expand more',
  收起: 'Collapse',
  专题教程: 'Tutorial',
  '快捷支付，使用欧易web3钱包，交易所无法识别':
    'Quick payment, use the OKX Web3 wallet, the exchange cannot recognize',
  'USDT 支付': 'USDT Payment',
  '系统繁忙,未支付成功请联系客服':
    'Service busy, payment not successful, please contact customer service',
  确定: 'Confirm'
};
